import clsx from "clsx";
import { SearchIcon } from "lucide-react";

export const JobPipelineEmptyStateForFilters = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <div
      className={clsx(
        "flex flex-col items-center justify-center gap-6 bg-slate-50 py-28",
        className,
      )}
    >
      <SearchIcon className="h-[120px] w-[120px] stroke-[0.7px] text-slate-600" />
      <div className="flex flex-col items-center gap-4">
        <p className="text-3xl font-semibold text-slate-600">
          No candidates found
        </p>
        <p className="text-xl text-slate-500">
          We didn&apos;t find any candidates using the current filters
        </p>
      </div>
    </div>
  );
};
